// Responsive image helpers. Object-storage files are resized on the fly by GET /api/files/{path}?w=;
// Unsplash accepts a native `w` param. Anything else is returned untouched.
const WIDTHS = [480, 800, 1200, 1600];
// Wide editorial figures render up to ~1100px and must stay crisp on 2x displays.
export const WIDE_WIDTHS = [800, 1200, 1600, 2400];

export const imgUrl = (src, w) => {
  if (!src) return src;
  if (src.startsWith("/api/files/")) return `${src}?w=${w}`;
  if (src.includes("images.unsplash.com") && !/[?&]w=/.test(src)) return `${src}&w=${w}`;
  return src;
};

export const srcSet = (src, widths = WIDTHS) => {
  if (!src || !(src.startsWith("/api/files/") || src.includes("images.unsplash.com"))) return undefined;
  return widths.map((w) => `${imgUrl(src, w)} ${w}w`).join(", ");
};

// Spread onto <img>: sizes describes the rendered width so the browser picks the smallest fitting variant.
export const responsive = (src, sizes = "100vw", widths) => ({
  src: imgUrl(src, widths ? widths[widths.length - 1] : 1200),
  srcSet: srcSet(src, widths),
  sizes,
});
